import remoteServer from './remote-server'
import PropertyMap from './property-lister/map/controller'
import PropertyFilter from './property-lister/list/filter/controller'
import PropertyList from './property-lister/list/controller'
import PropertyFutureList from './property-lister/list/future-list/controller'
import events from '../../event-emitter'
import ViewModes from './view-modes'
import View from './view'
import Block from '../Block'


let instances = {}
export default function initFinder(rootSelctor) {
    if (!instances[rootSelctor] || !(instances[rootSelctor] instanceof Finder)) {
        instances[rootSelctor] = new Finder(rootSelctor)
    }
    return instances[rootSelctor]
}


class Finder extends Block {

    constructor(blockRoot) {
        super(blockRoot)
        this.contentRoot = this.root.find('.finder__property-view > .container')
        this.view = new View(this)
        this.holdInteraction = false
        this.activePropView = ''

        /**
         * @type {City[]}
         */
        this.cities = (this.root.data('cities') || []).map(cd => new City(cd))
        this.cities.unshift(new City({
            name: 'Alla',
            id: 'all',
        }))

        this.actions = [
            {
                text: 'Lista alla bostäder',
                value: 'propList'
            },
            {
                text: 'Sök och filtrera',
                value: 'propFilter'
            },
            {
                text: 'Se alla på en karta',
                value: 'propMap'
            }
        ]

        var propActionButtons = this.root.find('[data-property-action]')

        this.buttons = {
            action: {
                all: propActionButtons,
                propList: propActionButtons.filter('[data-property-action=\'list-all\']'),
                propFilter: propActionButtons.filter('[data-property-action=\'filter-all\']'),
                propMap: propActionButtons.filter('[data-property-action=\'map-all\']'),
                propFutureList: propActionButtons.filter('[data-property-action=\'list-future\']'),
            },
            modes: this.root.find('.switch-grid'),
        }

        this.initCities()
        this.initActions()


        //--- INIT COMPONENTS ---//
        this.remoteServer = remoteServer()

        this.propList = new PropertyList(this)
        this.propFilter = new PropertyFilter(this)
        this.propMap = new PropertyMap(this)
        this.propFutureList = new PropertyFutureList(this)


        //--- BIND UI ---//
        // TODO: remove all actions related this.buttons if it's definitely not needed
        this.buttons.action.propList.on('click', event => {
            event.preventDefault()
            this.setPropView('propList')
        })
        this.buttons.action.propFilter.on('click', event => {
            event.preventDefault()
            this.setPropView('propFilter')
        })
        this.buttons.action.propMap.on('click', event => {
            event.preventDefault()
            this.setPropView('propMap')
        })
        this.buttons.action.propFutureList.on('click', event => {
            event.preventDefault()
            this.setPropView('propFutureList')
        })


        //--- DEFINE VIEW MODES ---//
        this.viewModes = new ViewModes()

        this.viewModes.addMode({
            displayName: 'Detailed view',
            slug: 'detail-mode',
            faIconSlug: 'fa-list',
            onModeOn: mode => {
                this.contentRoot.addClass(mode.slug)
            },
            onModeOff: mode => {
                this.contentRoot.removeClass(mode.slug)
            },
        })

        this.viewModes.addMode({
            // isActive: true,
            displayName: 'List view',
            slug: 'list-mode',
            faIconSlug: 'fa-th-list',
            onModeOn: mode => {
                this.contentRoot.addClass(mode.slug)
            },
            onModeOff: mode => {
                this.contentRoot.removeClass(mode.slug)
            },
        })

        this.viewModes.addMode({
            isActive: true,
            displayName: 'Grid view',
            slug: 'grid-mode',
            faIconSlug: 'fa-th-large',
            onModeOn: mode => {
                this.contentRoot.addClass(mode.slug)
            },
            onModeOff: mode => {
                this.contentRoot.removeClass(mode.slug)
            },
        })

        this.setPropView('propList', false, true)
    }

    setViewMode(mode) {
        this.viewModes.setActive(mode)
        return this
    }

    writeContent(html) {
        this.removeContent()
        html instanceof Array
        ? html.map(block => this.contentRoot.append(block))
        : this.contentRoot.append(html)

        events.emit('finder::writeContent')
        this.root.addClass('content-written')
    }

    removeContent() {
        this.contentRoot.empty()
    }

    hold() {
        this.holdInteraction = true
        this.root.addClass('hold-interaction')
    }

    release() {
        this.holdInteraction = false
        this.root.removeClass('hold-interaction')
    }


    unsetPropView() {
        if (this.holdInteraction) {
            return
        }

        this.removeContent()
        this.activePropView = ''
        this.buttons.action.all.removeClass('active')
        this.root.removeClass('content-written').removeClass('view-selected')
    }


    setPropView(slug, forceReload = false, forceRun = false) {
        if (this.holdInteraction && !forceRun) {
            return
        }

        if (forceReload !== 'force' && this.activePropView === slug) {
            return
        }

        this.root.addClass('view-selected')
        this.buttons.action.all.removeClass('active')
        this.hold()

        this.remoteServer.request(data => {
            function propFilter(property) {
                if (property.props.status) {
                    return true
                } else {
                    console.warn('Invalid project', property)
                    return false
                }
            }

            let dt = {
                projekts: data.projekts.filter(propFilter),
                objekts: data.objekts.filter(propFilter),
                areas: data.areas
            }

            let selectedCities = this.cities.filter(c => c.selected)

            let selectedCitiesIDs = selectedCities.map(sc => sc.id)
            let selectedDistrictsIDs = [].concat.apply([], selectedCities
                .map(c => c.districts.filter(d => d.selected))).map(sd => sd.id)

            const filterProperty = prop => {
                let districtMatch = selectedDistrictsIDs.includes('all')
                    || (prop.city.districts || []).reduce((res, d) => {
                        return res ? res : selectedDistrictsIDs.includes(d.id)
                    }, false)
                let cityMatch = selectedCitiesIDs.includes('all')
                    || selectedCitiesIDs.includes(prop.city.id)
                return districtMatch && cityMatch
            }

            // Filter by city and district
            dt.projekts = dt.projekts.filter(filterProperty)
            dt.objekts = dt.objekts.filter(filterProperty)
            dt.areas = dt.areas.filter(filterProperty)

            this.activePropView = slug
            this.buttons.action[slug].addClass('active')

            // Write generated markup to content container
            this.writeContent(this[slug].manage(dt).render())

            this.release()
        })
    }

    refresh() {
        this.setPropView(this.activePropView, 'force')
    }

    initCities() {
        let citySelectContainer = this.root.find('.fcontrol__prime__city'),
            cityDistrictSelectContainer = this.root.find('.fcontrol__prime__city-district')

        citySelectContainer.empty()
        cityDistrictSelectContainer.empty()

        // TODO: remove at all district selector if it's needed
        const getDistrictSelector = city => {
            let selectedDistricts = city.districts.filter(d => d.selected)
            let ds = this.view.ultraSelect({
                buttonText: selectedDistricts.length === 1 && !selectedDistricts[0].isAll()
                            ? selectedDistricts[0].name
                            : 'Område',
                list: city.districts.map(district => {
                    return {
                        content: district.name,
                        events: {
                            event: 'click',
                            callback: event => {
                                event.preventDefault()
                                cityDistrictSelectContainer.addClass('is-active')
                                if (district.isAll()) {
                                    city.districts.forEach(c => c.select())
                                } else {
                                    city.districts.forEach(c => c.deselect())
                                    district.select()
                                }
                                $(ds).find('.u-select__button__name').html(district.name)
                                this.refresh()
                            },
                        },
                    }
                }),
            })
            if (city.isAll() || city.districts.length <= 1) {
                $(ds).addClass('s-disabled')
            }
            return ds
        }

        const getCitySelector = currentCity => {
            // Populate city selectors
            let cs = this.view.ultraSelect({
                buttonText: currentCity ? currentCity.name : 'Stad',
                list: this.cities.map(city => {
                    return {
                        content: city.name,
                        events: {
                            event: 'click',
                            callback: (event, element) => {
                                event.preventDefault()
                                $(cs).find('.u-select__menu__item__link').removeClass('selected')
                                element.classList.add('selected')
                                if (city.isAll()) {
                                    this.cities.forEach(c => c.select())
                                } else {
                                    this.cities.forEach(c => c.deselect())
                                    city.select()
                                }
                                $(cs).find('.u-select__button__name').html(city.name)
                                cityDistrictSelectContainer
                                    .empty()
                                    .append(getDistrictSelector(city))

                                this.refresh()
                            },
                        },
                    }
                }),
            })
            return cs
        }


        // Check GET parameters and assign defaults
        let cityMatch = location.search.match(/[?&]city-id=([^&]+)/),
            selectedCity = null

        if (cityMatch) {
            this.cities.forEach(c => c.deselect())
            let selected = this.cities.filter(c => '' + c.id === '' + cityMatch[1])
            if (selected.length) {
                selectedCity = selected[0]
                selectedCity.select()
                let districtMatch = location.search.match(/[?&]district-id=([^&]+)/)
                if (districtMatch) {
                    selectedCity.districts.forEach(d => d.deselect())
                    selectedCity.districts.filter(d => '' + d.id === '' + districtMatch[1]).forEach(d => d.select())
                }
            }
        } else {
            this.cities.forEach(c => c.select())
        }

        citySelectContainer.append(getCitySelector(selectedCity))
        cityDistrictSelectContainer.append(getDistrictSelector(selectedCity ? selectedCity : this.cities[0]))

        return this
    }

    initActions() {
        let actionSelectContainer = this.root.find('.fcontrol__prime__city-action')

        actionSelectContainer.append(this.view.ultraSelect({
            buttonText: 'Lista alla bostäder',
            list: this.actions.map((button) => {
                return {
                    attributes: {value: button.value},
                    content: button.text,
                    events: {
                        event: 'click',
                        callback: (event, element) => {
                            event.preventDefault()
                            actionSelectContainer.find('.u-select__menu__item__link').removeClass('selected')
                            element.classList.add('selected')
                            this.setPropView(element.parentNode.getAttribute('value'))
                            actionSelectContainer.find('.u-select__button__name').html(button.text)
                        },
                    },
                }
            })
        }))
    }
}


class PropertyLocation {
    constructor(data) {
        this.name = data.name
        this.id = data.id
        this.selected = false
    }

    select() {
        this.selected = true
    }

    deselect() {
        this.selected = false
    }

    isAll() {
        return !this.id || this.id === 'all'
    }
}

class District extends PropertyLocation {
}

class City extends PropertyLocation {
    constructor(data) {
        super(data)
        /**
         * @type {District[]}
         */
        this.districts = (data.districts || []).map(dd => new District(dd))
        this.districts.unshift(new District({
            name: 'Alla',
            id: 'all',
        }))
    }

    select() {
        this.selected = true
        this.districts.forEach(d => d.select())
    }

    deselect() {
        this.selected = false
        this.districts.forEach(d => d.deselect())
    }

    hasDistrict(name) {
        return this.districts.reduce((res, d) => res ? res : d.name === name, false)
    }
}
